import { h, resolveComponent } from 'vue'

export function propsFactory () {
  return {
    href: String,
    rel: String,
    target: { type: String, default: '_self' },
    disabled: Boolean,
    active: Boolean,
    // router-link props (vue-router 4 dropped append/event/exact/tag; kept for API compatibility)
    activeClass: { type: String, default: 'router-link-active' },
    append: Boolean,
    event: { type: [String, Array], default: 'click' },
    exact: Boolean,
    exactActiveClass: { type: String, default: 'router-link-exact-active' },
    replace: Boolean,
    routerTag: { type: String, default: 'a' },
    to: [String, Object]
  }
}
export const props = propsFactory()

export const CLink = {
  name: 'CLink',
  inheritAttrs: false,
  props,
  setup (props, { attrs, slots }) {
    return () => {
      const RouterLink = props.to && !props.disabled ? resolveComponent('RouterLink') : null
      const isRouter = RouterLink && typeof RouterLink !== 'string'
      const rel = props.target === '_blank' && !props.rel ? 'noopener' : props.rel
      const href = props.href || '#'
      const supplied = attrs.onClick
      const onClick = (e) => {
        if (props.disabled && e instanceof Event) {
          e.stopPropagation()
          e.stopImmediatePropagation()
        } else if (supplied) {
          (Array.isArray(supplied) ? supplied : [supplied]).forEach((fn) => fn(e))
        }
        if ((!isRouter && href === '#') || props.disabled) e.preventDefault()
      }
      const cls = [attrs.class, { disabled: props.disabled, active: props.active }]
      const common = {
        ...attrs,
        class: cls,
        rel,
        target: props.target,
        tabindex: props.disabled ? '-1' : attrs.tabindex,
        onClick
      }
      if (isRouter) {
        // vue-router 4: no `tag` prop -> render the <a> ourselves via the custom slot
        return h(RouterLink, {
          to: props.to,
          replace: props.replace,
          custom: true,
          activeClass: props.activeClass,
          exactActiveClass: props.exactActiveClass
        }, {
          default: ({ href: routeHref, navigate, isActive, isExactActive }) => h(props.routerTag || 'a', {
            ...common,
            href: routeHref,
            class: [cls, {
              [props.activeClass]: props.exact ? isExactActive : isActive,
              [props.exactActiveClass]: isExactActive
            }],
            onClick: (e) => {
              onClick(e)
              if (!props.disabled && !e.defaultPrevented) navigate(e)
            }
          }, slots.default && slots.default())
        })
      }
      return h('a', {
        ...common,
        href,
        'aria-disabled': props.disabled ? 'true' : null
      }, slots.default && slots.default())
    }
  }
}
export default CLink
